<script>
  import Button from '@components/buttons/button.svelte'
  import { colors } from '@lib/utils/colors'
  import { cn } from '@lib/utils'

  let { color = 'primary', class: className, ...props } = $props()

  let colorObject = $derived(colors[color])

  let buttonClass = $derived(cn(colorObject.bold, className))
</script>

<Button variant="bold" size="lg" class={buttonClass} {...props} />
